// @flow

import _ from 'lodash';
import moment from 'moment';
import mapSeries from 'async/mapSeries';

import App from './App.jsx';

import {load_stats} from './show_stats.js';
import {takeDir, takeFilename} from './utils.js';
import {fetch_png} from './fetch_things.js';

import type {T_ImgFile} from './Img.js';
import type {T_ErrOk, T_EscalaLyr} from './types.js';
import type {T_Stats} from './Stats.jsx';


export type T_MixResult = {error: string} | string;


export type T_NextMixResult = (res: T_MixResult) => void;


export type T_NextLyrs = (lyrs: Array<?T_EscalaLyr>) => void;


type T_PairDirStats = {
  dir  : string,
  stats: Array<T_Stats>
};



// NOTE: esta función podría devolver algunos nulls en la respuesta.
// Si devolvió algunos nulls, es que no pudo encontrar el lyr. Siempre debes chequear los resultados.

// NOTE: en la función get_lyrs_of, si no hay lyrs, pero si hay lims, los T_EscalaLyr van a estar incompletos
// En ese caso, van a tener {elemRange, inverted}, que es lo único que necesita la función image_mix.
// Por esa razón, get_lyrs_of no se exporta.

export function get_lyrs_of(app: App, images: Array<string>, next: T_NextLyrs): void {
  mapSeries(images, (path, callback) => {
    fetch_png(app, path, (result: T_ImgFile | string) => {
      if (typeof result === 'string') {
        callback(null, null);
      }
      else {
        const img = (result: T_ImgFile);
                
        if (img.info_lim != null) {      // NOTE: SI SE DETECTÓ UN .LIM, ESTE TOMA PRECEDENCIA SOBRE EL LYR.
          callback(null, img.info_lim.error ? null : img.info_lim);
        }
        else if (img.lyr != null) {
          callback(null, img.lyr);
        }
        else {
          callback(null, null);
        }
      }
    });
  }, (err, lyrs) => {
    next(lyrs);
  });
}



export default function image_mix(app: App, out_dir: string, images: Array<string>, next: T_NextMixResult): void {
  const in_dirs   = _.uniq(images.map(takeDir));
  
  mapSeries(in_dirs, (dir: string, callback) => {
    app.get_first_culti(dir, (culti_path: string) => {
      load_stats(app, culti_path, false, false, true, (stats: Array<T_Stats>) => {
        callback(null, {dir, stats});
      });
    });
  }, (err, stats_dirs: Array<T_PairDirStats>) => {
    const get = (png_path: string) => {
      const ss = stats_dirs.find(pair => pair.dir === takeDir(png_path));
      
      if (ss != null) {
        return ss.stats.find(st => st.png === takeFilename(png_path));
      }
    };
    
    const has3 = images.length >= 3,
          i1   = get(images[0]),
          i2   = get(images[1]),
          i3   = has3 ? get(images[2]) : null,
          t1   = i1 != null ? i1.path : 'NO',
          t2   = i2 != null ? i2.path : 'NO',
          t3   = i3 != null ? i3.path : 'NO',
          e1   = i1 != null ? i1.elem : '',
          e2   = i2 != null ? i2.elem : '',
          e3   = i3 != null ? i3.elem : '',
          date = moment().format('DD-MMM-YYYY'),
          out  = `${out_dir}/Mapa_Tematico_${[e1, e2, e3].filter(_.identity).join('_')}_${date}.png`;
    
    get_lyrs_of(app, images, (lyrs) => {
      const [lyr1, lyr2, lyr3] = lyrs;
      
      if (lyr1 == null || lyr2 == null || (has3 && lyr3 == null)) {
        const elem = lyr1 == null ? e1 : (lyr2 == null ? e2 : e3);
        
        next({error: `No pude encontrar la escala de ${elem}.`});
      }
      else {
        const [min1, max1] =                 lyr1.elemRange,
              [min2, max2] =                 lyr2.elemRange,
              min3         = lyr3 != null ?  lyr3.elemRange[0] : 0,
              max3         = lyr3 != null ?  lyr3.elemRange[1] : 0,
              inv1         =                 lyr1.inverted ? 'True' : 'False',
              inv2         =                 lyr2.inverted ? 'True' : 'False',
              inv3         = lyr3 != null ? (lyr3.inverted ? 'True' : 'False') : 'False',
              lim1         = `&min1=${min1}&max1=${max1}`,
              lim2         = `&min2=${min2}&max2=${max2}`,
              lim3         = `&min3=${min3}&max3=${max3}`,
              lims         = `${lim1}${lim2}${lim3}`,
              invs         = `&inv1=${inv1}&inv2=${inv2}&inv3=${inv3}`,
              esc_family   = `&esc_family=${app.state.name_escala}`,
              esc_ncolor   = `&esc_ncolor=${app.state.num_colors_escala}`,
              esc_invert   = `&esc_invert=${app.state.inv_escala ? 'True' : 'False'}`,
              esc          = `${esc_family}${esc_ncolor}${esc_invert}`,
              url          = `${app.remote}/image-mix/?i1=${t1}&i2=${t2}&i3=${t3}&out=${out}&session_id=${app.session()}`;
        
        fetch(`${url}${lims}${invs}${esc}`).then(resp => resp.json()).then((response: T_ErrOk) => {
          if (typeof response.error === 'string') {
            next({error: response.error});
          }
          else {
            next(out);
          }
        });
      }
    });
  });
}



// WEBPACK FOOTER //
// ./src/image_mix.js